export function combineReducers(reducers) {
  function combinedGetInitialState(props) {
    return reducers.reduce((state, { getInitialState }) => ({
      ...state,
      ...getInitialState(props),
    }), {});
  }

  function combinedReducer(state, action) {
    return reducers.reduce(
      (newState, { reducer }) => reducer(newState, action),
      state
    );
  }

  return { reducer: combinedReducer, getInitialState: combinedGetInitialState };
}
